import PropTypes from "prop-types";

// MUI
import { Button, Typography } from "@mui/material";

const ReviewAndSignButton = (props) => {
	const { text = "", onClick = () => {} } = props;
	return (
		<Button
			disableElevation
			variant="contained"
			className={"btn-primary"}
			sx={{ textTransform: "none", height: "30px", borderRadius: "6px" }}
			onClick={onClick}
		>
			<Typography fontFamily={"var(--font-family-v2)"} color={"white"}>
				{text}
			</Typography>
		</Button>
	);
};
ReviewAndSignButton.propTypes = {
	text: PropTypes.string,
	onClick: PropTypes.func,
};

export default ReviewAndSignButton;
